import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  var { params, pageAssetsData, inProgress, error, intl  } = props;
  const pageId = params.pageId || props.pageId;
  const jsonData = pageAssetsData;
  
  const keysToTranslate = new Set([]);
  // Function to replace placeholders with translations
  function replaceContent(obj, keysToTranslate, intl) {
    if (typeof obj === 'string') {
      // Only replace if the string is in the keysToTranslate set
      return intl.messages[obj] ? intl.formatMessage({ id: obj }) : obj;
    } else if (Array.isArray(obj)) {
      return obj.map(item => replaceContent(item, keysToTranslate, intl));
    } else if (typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, replaceContent(value, keysToTranslate, intl)])
      );
    }
    return obj;
  }

    // Replace content in the JSON data
    pageAssetsData = replaceContent(jsonData, keysToTranslate, intl);

  if (!inProgress && error?.status === 404) {
    return <NotFoundPage />;
  }

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[pageId]?.data}
      inProgress={inProgress}
      schemaType="Article"
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(
  withRouter,
  injectIntl,
  connect(mapStateToProps)
)(CMSPageComponent);

export default CMSPage;
